import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/core/jsonapi/service';
import {
    ServiceLogFile, ServiceLogInstance, ServiceLogResource, ServiceLogTail
} from '../_types/service-log';

/// Consultas del visor de logs. Ninguna es JSON:API: se llaman con this.http heredado y devuelven
/// JSON normal. Todas pasan por loaderService.skipRequest, porque el visor sondea cada pocos
/// segundos y el spinner global no pararía nunca.
@Injectable({
    providedIn: 'root'
})
export class ServiceLogsService extends Service<ServiceLogResource> {
    public override type = 'serviceLogs';
    public override url = 'common/serviceLogs';

    public getCatalog(): Observable<ServiceLogInstance[]> {
        return this.fetchJson<ServiceLogInstance[]>('');
    }

    /// Con offset nulo devuelve la cola del fichero; a partir de ahí se manda el offset recibido en
    /// la vuelta anterior y sólo viaja lo nuevo.
    public getTail(instance: string, service: string, offset: number | null): Observable<ServiceLogTail> {
        const path = `/${encodeURIComponent(instance)}/${encodeURIComponent(service)}/tail`;
        return this.fetchJson<ServiceLogTail>(offset === null ? path : `${path}?offset=${offset}`);
    }

    public getFiles(instance: string, service: string): Observable<ServiceLogFile[]> {
        return this.fetchJson<ServiceLogFile[]>(`/${encodeURIComponent(instance)}/${encodeURIComponent(service)}/files`);
    }

    /// Como blob y no como <a href>: el endpoint exige la cabecera Authorization, que un enlace
    /// normal del navegador no lleva.
    public downloadFile(instance: string, service: string, fileName: string): Observable<Blob> {
        const url = this.getAPIUrl()
            + `/${encodeURIComponent(instance)}/${encodeURIComponent(service)}/files/${encodeURIComponent(fileName)}/download`;
        return this.http.get(url, { responseType: 'blob' });
    }

    /// this.get(id) ya existe en Service<R> para JSON:API; se llama distinto para no chocar con ese
    /// miembro público de la clase base.
    private fetchJson<T>(path: string): Observable<T> {
        const url = this.getAPIUrl() + path;
        this.loaderService.skipRequest(url);
        return this.http.get<T>(url);
    }
}
